import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { STATIC_VALUE } from '../../shared/configuration/static.value';

import { StorageService } from '../../shared/services/storage.service';
import { PageNavigationService } from '../../shared/services/page-navigation.service';
import { LayoutService } from '../../shared/services/layout.service';
import { NceService } from '../services/nce.service';

@Component({
    selector: 'nce-confirmation',
    templateUrl: 'confirmation.component.html'
})

export class NceConfirmationComponent implements OnInit{

    vStatus: string;

    vNCERequestID: string;

    constructor(
        private _nceService: NceService,
        private _layoutService: LayoutService, 
        private _pageNavigationService: PageNavigationService,
        private _storageService: StorageService,
        private _activatedRoute: ActivatedRoute
    ) {
        
    }

    ngOnInit() {
        this._layoutService.setCurrentPage('nce-confirmation');
        this._layoutService.setNCEFlow('nce-payment');
        let extensionNCE = this._storageService.getSessionItem('extensionNCE');
        this.vNCERequestID = this._nceService.getRequestID();
        this._nceService.getPaymentAvailability().then(
            (resolve) => {
                if(resolve['data'].payment) { // contractor
                    let transactionParam = this._activatedRoute.snapshot.queryParams;
                    if(transactionParam["id"] !== undefined && transactionParam["id"] === this._nceService.vNCEData.onepay_reference_id){
                        this.loadTransaction(transactionParam, extensionNCE);
                    } else {
                        this._pageNavigationService.navigate(['home']);
                    }
                } else { // government
                    if(this._storageService.getSessionItem('extensionNCE') === '1'){
                        this.vStatus = this.getNCEStatus().APPROVED;
                    } else {
                        this.vStatus = this.getNCEStatus().PENDING_BRIEFING_DOCUMENT;
                    }
                    this._nceService.resetAllNCEData();
                    this._storageService.setSessionItem('extensionNCE', extensionNCE);
                }
            },
            (reject) => {
                this._nceService.resetAllNCEData();
            }
        );
    }

    // ngOnDestroy(){
    //     if(this._activatedRoute.snapshot.queryParams["failure_reason"] === undefined){
    //         this._storageService.removeSessionItem('extensionNCE');
    //     }
    // }

    loadTransaction(transactionParam, pExtensionNCE){
        this._nceService.loadTransaction(transactionParam["failure_reason"]).then(
            (resolve) => {
                this.vStatus = resolve['data'].status;
                if(this.vStatus === this.getNCEStatus().PAYMENT_PENDING){
                    this._nceService.setIsPaymentPending(true);
                    let vLink = ["nce-application/payment"];
                    this._pageNavigationService.navigate(vLink);
                } else {
                    this._nceService.resetAllNCEData();
                    this._storageService.setSessionItem('extensionNCE', pExtensionNCE);
                }
            },
            (reject) => {
                this._nceService.resetAllNCEData();
            }
        );
    }

    isLoading(){
        return this._nceService.isLoading();
    }

    getNCEStatus(){
        return STATIC_VALUE.ALL_NCE_STATUS;
    }

    goNext(){
        let vLink;
        
        if(this.vStatus === this.getNCEStatus().APPROVED) {
            vLink = ['nce-application/final-approval'];
        } else if(this.vStatus === this.getNCEStatus().PENDING_BRIEFING_DOCUMENT) {
            vLink = ['nce-application/briefing-document'];
        }
        this._pageNavigationService.navigate(vLink);
    }

    goToHome(){
        this._nceService.resetAllNCEData();
        let vLink = ['home'];
        this._pageNavigationService.navigate(vLink);
    }
}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/nce/components/confirmation.component.ts